const isBrazil = (countryCode?: string) => {
  return countryCode?.toUpperCase() === 'BR';
};

const isInternacional = (countryCode?: string) => {
  return countryCode?.toUpperCase() !== 'BR';
};

const isLanguagePortuguese = (langCode?:string) => {
  return langCode?.toUpperCase() === 'PT'
}

const isLanguageEnglish = (langCode?:string) => {
  return langCode?.toUpperCase() === 'EN'
}

const findDesiredCountry = (
  countries: Array<{ code: string; name: string }> | undefined,
  desiredCountry: string | undefined
): { code: string; name: string } => {
  const desired = countries?.find(
    (item) => item.code.toUpperCase() === desiredCountry?.toUpperCase()
  );
  if (!desired || !desiredCountry) {
    return { code: 'BR', name: 'Brazil' };
  }
  return desired;
};

export { findDesiredCountry, isBrazil, isInternacional, isLanguageEnglish, isLanguagePortuguese };

